module.exports = __webpack_public_path__ + "media/images/Results-Cohort1_2_IncreasedChance-4e3ae6d3835cc3e6df1600ef9bedd5f5.png";